import { render, staticRenderFns } from "./side-menu-element.vue?vue&type=template&id=2dbc5951&scoped=true"
import script from "./side-menu-element.vue?vue&type=script&lang=js"
export * from "./side-menu-element.vue?vue&type=script&lang=js"
import style0 from "./side-menu-element.vue?vue&type=style&index=0&id=2dbc5951&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc5951",
  null
  
)

export default component.exports